.user-menu {
  position: relative;
  display: flex;
  align-items: center;
}

.logged-in-menu {
  position: relative;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}
.qumra-user-button{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 45px;
  border-radius: 99999999px; ;

}
.menu-dropdown {
  position: absolute;
  top: 45px;
  left: 0;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  width: 150px;
  z-index: 10;
}

.menu-item {
  display: block;
  padding: 10px;
  text-decoration: none;
  color: #333;
  border-bottom: 1px solid #eee;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.login-link {
  text-decoration: none;
  color: inherit;
}

.user-icon {
  font-size: 40px;
  /* استخدم أيقونة مناسبة هنا */
}